/**
 * Build generation context for ICF section edits (mirrors protocol Document Editor pattern).
 * System / predefined prompts are passed in context only — not shown in the UI.
 */

export function buildIcfSectionGenerateContext({
  section,
  priorVersions = [],
  predefinedPrompt = '',
  protocolContext = '',
}) {
  const parts = [];

  const currentOutput = String(section?.output || '').trim();
  if (currentOutput) {
    parts.push(`Current Section Content:\n${currentOutput}`);
  }

  if (predefinedPrompt) {
    parts.push(
      `Original Section Generation Guidelines (internal reference — apply silently, do not repeat verbatim unless the user requests it):\n${predefinedPrompt}`
    );
  }

  if (protocolContext) {
    parts.push(`Protocol Reference:\n${protocolContext}`);
  }

  const sortedVersions = [...priorVersions].sort(
    (a, b) => (a.versionNumber || 0) - (b.versionNumber || 0)
  );

  if (sortedVersions.length > 0) {
    const versionLines = sortedVersions.map((version) => {
      const chunks = [`Version ${version.versionNumber || '?'}:`];
      if (version.prompt) {
        chunks.push(`User Edit Instructions: ${version.prompt}`);
      }
      if (version.output) {
        chunks.push(`Output: ${version.output}`);
      }
      chunks.push('---');
      return chunks.join('\n');
    });
    parts.push(`Version History:\n${versionLines.join('\n')}`);
  }

  const sectionContext = String(section?.context || '').trim();
  if (sectionContext) {
    parts.push(`Section Context:\n${sectionContext}`);
  }

  return parts.join('\n\n');
}

export function buildIcfUserEditGenerationPrompt(userInstructions, sectionTitle = '') {
  const instructions = String(userInstructions || '').trim();
  const titleLine = sectionTitle ? `Section: ${sectionTitle}\n\n` : '';

  return `${titleLine}Revise this Informed Consent Form (ICF) section according to the user's editing instructions below.

Requirements:
- Apply only the changes described in the user instructions.
- Preserve all existing HTML tags, attributes, classes, styles, list/table structure, and heading levels.
- Revise human-readable text inside tags only when needed to fulfill the instructions.
- Keep regulatory tone appropriate for an ICF (plain language, participant-facing).
- Return the full revised HTML for this section only (no wrapper document).

User editing instructions:
${instructions}`;
}
